import { Component } from '@angular/core';
import { AdminHeaderComponent, AdminToastHostComponent } from '@cnt-admin/ui';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';

@Component({
  selector: 'curbnturf-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [AdminHeaderComponent, AdminToastHostComponent, IonApp, IonRouterOutlet],
})
export class AppComponent {
  title = 'curbnturf-admin';
}
